__turbopack_context__.v({
  "action": "Gallery-module-scss-module__wfu5LG__action",
  "badge": "Gallery-module-scss-module__wfu5LG__badge",
  "fade-in": "Gallery-module-scss-module__wfu5LG__fade-in",
  "gallery": "Gallery-module-scss-module__wfu5LG__gallery",
  "galleryClickable": "Gallery-module-scss-module__wfu5LG__galleryClickable",
  "image": "Gallery-module-scss-module__wfu5LG__image",
  "item": "Gallery-module-scss-module__wfu5LG__item",
  "list": "Gallery-module-scss-module__wfu5LG__list",
  "list-1": "Gallery-module-scss-module__wfu5LG__list-1",
  "list-2": "Gallery-module-scss-module__wfu5LG__list-2",
  "list-3": "Gallery-module-scss-module__wfu5LG__list-3",
  "list-4": "Gallery-module-scss-module__wfu5LG__list-4",
  "list-5": "Gallery-module-scss-module__wfu5LG__list-5",
  "no-transform": "Gallery-module-scss-module__wfu5LG__no-transform",
  "rotate": "Gallery-module-scss-module__wfu5LG__rotate",
});
